<template>
  <div class="dashboard-layout">
    <DashboardSidebar class="animate__animated animate__fadeInDown" />

    <div class="dashboard-content">
      <!-- <DashboardNavbar /> -->

      <router-view class="app-content-container" />

      <Footer class="animate__animated animate__fadeInUp" />
      <!-- <div class="app-content">
      </div> -->
    </div>
  </div>
</template>
<script>
// import DashboardNavbar from "./components/DashboardNavbar.vue";
import DashboardSidebar from "./components/DashboardSidebar.vue";
import Footer from "./components/Footer.vue";

export default {
  components: {
    // DashboardNavbar,
    DashboardSidebar,
    Footer,
  },
};
</script>
